<ng-template #competencias>
  @if(dataTitulo){
  <app-titledescription
    [title]="dataTitulo.descripcion"
    [description]="'Aca se muestra las competencias del titulo seleccionado'"
  ></app-titledescription>
  }
  <ng-template #tableCompetenciasActuales>
    @if(dataFetch){
    <ng-template #extraButton>
      <div class="flex items-center mb-2">
        <app-button
          [text]="'Descargar PDF'"
          [typeButton]="'button'"
          (click)="downloadCompetenciasNivelPDF()"
          color="warn"
          [isDisabled]="isLoadingPDF()"
          [tooltip]="'Competencias del nivel seleccionado'"
        ></app-button>
        <span *ngIf="isLoadingPDF()" class="ml-2 align-middle">
          <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
        </span>
      </div>
    </ng-template>
    <app-table
      [height]="'350px'"
      [columnsNames]="columnNamesCompetencias"
      [dataFetch]="dataFetch"
      [totalItems]="totalItems"
      [actions]="actions"
      [actionsDeletedItems]="actionsDeletedItems"
      (fetchAgain)="fetchData($event.options, $event.ignoreCache)"
      [filterable]="true"
      [selectable]="true"
      [dataSelect]="dataSelectNiveles"
      (emitValueSelected)="selectValueNivel($event)"
      (callCustomFunction)="openModal($event)"
      [apiService]="competenciaService"
      [labelSelect]="'Nivel'"
      [labelFilter]="'Materia'"
      [templateRefExtraButtons]="extraButton"
      [showExtraButtonsTemplateRef]="nivelSelected ? true : false"
      [templateRef]="templateAction"
      (returnActionEvent)="formIsSubmit()"
    >
    </app-table>
    }
  </ng-template>

  <!-- table para agregar nuevas competencias al titulo -->
  <ng-template #tableaddCompetencias>
    @if(nivelSelected){
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel
        hideToggle
        #expansionPanel
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h1 class="text-md text-white">Agregar Nuevas Competencias</h1>
          </mat-panel-title>
          <mat-panel-description class="flex justify-between">
            <mat-panel-description class="flex items-center justify-between w-full">
              <span>{{ panelOpenState() ? 'Click para cerrar' : 'Click para expandir' }}</span>
              <div class="flex items-center gap-2">

                <mat-icon>{{ panelOpenState() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </div>
            </mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-form
          #form
          [fields]="fieldsAddCompetenciasConfig"
          (selectFieldValueEmit)="selectedValueFromForm($event)"
        ></app-form>

        <!-- materias a agregar -->
        <mat-divider></mat-divider>
        <div class="flex mt-2 gap-4">
          <div class="w-64 flex-1 ...">
            <h1 class="mb-2 text-gray-700 bg-gray-300 rounded-lg text-center">
              Materias a agregar
            </h1>
            <div class="table-container" style="position: relative;">
              <app-table
                #materiasToAdd
                [height]="'350px'"
                [columnsNames]="columnNamesMaterias"
                [dataFetch]="dataMaterias"
                [totalItems]="totalItemsAddMaterias"
                (fetchAgain)="filtrarPorDescripcion($event.options, $event.ignoreCache)"
                [clickable]="true"
                [filterable]="true"
                [labelFilter]="'Materia'"
                [dataSelect]="dataSelectNiveles"
                (returnClickedRows)="getClickedRows($event)"
                [apiService]="materiaService"
                [mainFilterField]="'nivel_id'"
                [pagination]="true"
                [pageSize]="50"
                ></app-table>
                @if(spinner){
                <div class="spinner-overlay">
                  <mat-spinner></mat-spinner>
                </div>
              }
            </div>
              <!-- (fetchAgain)="getMaterias($event)" -->
          </div>
          <div class="w-32 flex-1 ...">
            <h1 class="text-xl mb-2 text-gray-700 bg-gray-300 rounded-lg text-center">
              Competencias agregadas
            </h1>
            <mat-list role="list">
              <app-table
                #materiasAdded
                [height]="'350px'"
                [columnsNames]="columnNamesMaterias"
                [dataFetch]="dataAddMaterias"
                [totalItems]="dataAddMaterias.total_items"
                (returnClickedRows)="getClickedRows($event)"
                [actions]="materiasAddedActions"
                (callCustomFunction)="deleteRow($event)"
                [pagination]="false"
                [apiService]="materiaService"
              ></app-table>
            </mat-list>
          </div>
        </div>
        @if(errorMessage){
        <div class="text-red-700 font-normal text-md mt-2 ml-2">
          {{ errorMessage }}
        </div>
        }
        <!-- botones guardar y limpiar -->
        <mat-action-row>
          <app-button [text]="'Guardar'" (click)="submitForm()"></app-button>
          <app-button
            [text]="'Limpiar Todas'"
            [type]="'button'"
            [matButtonAparence]="'outlined'"
            (click)="clearAllMateriasAdded()"
          ></app-button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    }
  </ng-template>
  <app-card
    [templateRefContent]="tableCompetenciasActuales"
    [templateRefFooter]="tableaddCompetencias"
  ></app-card>
</ng-template>

<!-- actions -->
<ng-template #templateAction>
  @if(templateView){
      @if(competenciaDetail){
        <app-crud-view
        [data]="castToObject(competenciaDetail)"
        [columnNames]="columnNamesCompetencias"
        [backButton]="false"
        [actionButtons]="false"
        [id]="competencia_id"
        [useCompactVersion]="true"
        ></app-crud-view>
      }
      @else{
        <div class="spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
      }
  }@else {
    <app-competencias-edit #modalEditCompetencia [id]="competencia_id"></app-competencias-edit>
  }
</ng-template>
<ng-template #templateDescriptionEdit>
  @if(competenciaDetail){
    <div class="mb-1">
      <span class="font-semibold text-gray-700 text-lg">Materia: </span>
      <span class="text-lg">{{ competenciaDetail.materia.descripcion }}</span>
    </div>
    <div>
      <span class="font-semibold text-gray-700 text-lg">Título: </span>
      <span class="text-lg">{{ competenciaDetail.titulo.descripcion }}</span>
    </div>
  }
</ng-template>
<app-base-page [templateRef]="competencias"></app-base-page>
